module.exports = __webpack_public_path__ + "img/item1.ad9252c9.png";